/* istanbul ignore file */
function loadFromUrl () {
    return document.location.search
}

export default loadFromUrl
